import { render, staticRenderFns } from "./ordersValidateAddress.vue?vue&type=template&id=71701c83&scoped=true"
import script from "./ordersValidateAddress.vue?vue&type=script&lang=js"
export * from "./ordersValidateAddress.vue?vue&type=script&lang=js"
import style0 from "./ordersValidateAddress.vue?vue&type=style&index=0&id=71701c83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71701c83",
  null
  
)

export default component.exports